(function($) {
    var pageUrl = escape(window.location.href);

    var facebookShareBase = "https://www.facebook.com/sharer/sharer.php?u=";
    var linkedInShareBase = "https://www.linkedin.com/shareArticle?mini=true&url=";

    $(".byline .share-facebook, .sharing-links .share-facebook").attr("href", facebookShareBase + pageUrl);
    $(".byline .share-linkedin, .sharing-links .share-linkedin").attr("href", linkedInShareBase + pageUrl);

    $('.message-box a.share-facebook').each(function () {
        $(this).attr('href', facebookShareBase + escape($(this).attr('data-shareurl')));
    });
    $('.message-box a.share-linkedin').each(function () {
        $(this).attr('href', linkedInShareBase + escape($(this).attr('data-shareurl')));
    });

    $(".byline .share-facebook, .byline .share-linkedin, .message-box a.share-facebook, .message-box a.share-linkedin, .sharing-links .share-facebook, .sharing-links .share-linkedin").click(function (e) {
        e.preventDefault();
        window.open($(this).attr('href'), 'skShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        return false;
    });

})(jQuery);
